<template>
  <div class="app-container">
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="知识名称">
        <el-input v-model="form.name" class="input" placeholder="请输入需要查询的知识名称" />
      </el-form-item>
      <el-form-item label="故事生成方式">
        <el-select v-model="form.type" placeholder="请选择方式" :clearable="true">
          <el-option label="问答形式-保险" value="qa" />
          <el-option label="问答形式-通用" value="common" />
          <el-option label="条款形式" value="term" />
          <el-option label="文本形式" value="text" />
        </el-select>
      </el-form-item>
      <div>
        <el-button @click="fetchData">查询</el-button>
        <el-button @click="addKnowledge">上传</el-button>
      </div>
    </el-form>
    <el-table
      ref="table"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      height="48"
      border=""
      :header-cell-style="{background:'rgb(244 244 244)'}"
    >
      <el-table-column align="center" label="知识名称" min-width="180" fixed="left">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="故事生成方式" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.identifyType | typeFilter }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建人" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.createdBy }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="上传模式" min-width="180">
        <template slot-scope="scope">
          {{ scope.row.origin | modeFilter }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="知识描述" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.description || '暂无' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="220" fixed="right">
        <template slot-scope="scope">
          <el-button @click="delItem(scope.row.id)">删除</el-button>
          <el-button @click="queryItem(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :pager-count="15"
      :total="totalNum"
      @current-change="handleCurrentChange"
    />
    <el-dialog
      title="知识块"
      :visible.sync="centerDialogVisible"
      :close-on-click-modal="false"
      width="50%"
      class="text-dialog"
      center
    >
      <div v-for="text in textBlocks" :key="text">{{ text }}</div>
    </el-dialog>
  </div>
</template>

<script>

import { queryKnowledge, knowledgeDel } from '@/api/knowledgeUpload'

export default {
  filters: {
    typeFilter(type) {
      switch (type) {
        case 'text':
          return '文本形式'
        case 'qa':
          return '问答形式-保险'
        case 'term':
          return '条款形式'
        case 'common':
          return '问答形式-通用'
      }
    },
    modeFilter(mode) {
      if (!mode) return '暂无'
      switch (mode) {
        case '0':
          return '手动输入'
        case '1':
          return '上传文件'
        case '2':
          return '外接知识库'
      }
    }
  },
  data() {
    return {
      list: null,
      listLoading: false,
      form: {
        name: '',
        type: ''
      },
      pageIndex: 0,
      totalNum: 0,
      centerDialogVisible: false,
      textBlocks: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    //  切换页码
    handleCurrentChange(page) {
      console.log('page', page)
      this.pageIndex = page - 1
      this.fetchData()
    },
    // 查列表数据
    async fetchData() {
      this.listLoading = true
      const params = {
        'name': this.form.name,
        'identifyType': this.form.type,
        'pageIndex': this.pageIndex,
        'pageSize': 15
      }
      await queryKnowledge(params).then(response => {
        this.totalNum = response.data.totalNum
        this.list = response.data.pageData
        this.$nextTick(() => {
          const tableBodyWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
          if (tableBodyWrapper) {
            tableBodyWrapper.scrollTo({
              top: 0
              // behavior: 'smooth' // 启用平滑滚动
            })
          }
        })
      }).finally(() => {
        this.listLoading = false
      })
    },
    // 新增知识
    addKnowledge() {
      this.$router.push({ name: 'uploadKnowledge' })
    },
    // 查看
    queryItem(detail) {
      console.log('scope', detail)
      this.centerDialogVisible = true
      this.textBlocks = detail.textBlocks
      // this.$router.push({ name: 'updateStory', params: { story: detail }})
    },
    // 删除知识
    delItem(id) {
      this.$confirm('此操作将删除该知识, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        knowledgeDel({ id }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功',
            duration: 2 * 1000
          })
          this.fetchData()
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.text-dialog{
  display: flex;
  justify-content: center;
  align-items: center;
  ::v-deep{
    .el-dialog{
      max-height: 70%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      border-radius: 5px;
      margin: 0 !important;
    }
    .el-dialog__body{
      overflow: auto;
      padding: 0 20px 20px 20px;
      div{
        margin-bottom: 5px;
      }
      div:last-child{
        margin-bottom: 0;
      }
    }
    .el-dialog__headerbtn{
      top: 23px;
    }
  }
}
::v-deep{
  .el-form{
    display: flex;
    justify-content: space-between;
    /* margin-bottom: 20px; */
  }
  .el-table{
    overflow: auto;
  }
  .el-form-item__content{
    display: flex;
    position: relative;
  }
  .el-button {
    margin-left: 0;
    padding: 10px 18px;
    margin-right: 20px;
    &:focus, &:hover{
      background: #FFF;
      border: 1px solid #DCDFE6;
      color: #606266;
    }
  }
  .el-button:last-child{
    margin-right: 0;
    color: #FFF;
    background-color: #409EFF;
  }
  .input{
    .el-input__inner {
      width: 300px;
    }
  }
  .el-pagination{
    margin: 20px 0 0;
    /* display: flex;
    justify-content: space-around; */
  }
}
</style>

